module.exports = __webpack_public_path__ + "static/illustration-09ced65135b5f71146c94a20c22bd2d8.svg";